import { getZ3kEntityById } from 'z3k-parser/lib/auxiliary';
import { getAnalogSensorThermometer, getBoilerAdapterThermometer, getRadioSensorThermometer, getThermometers, getWiredSensorThermometer, } from './utils';
import { Z3kSecondRoutes } from 'z3k-settings/routes/type';
function getSharedThermometer(thermometer, z3k_config, index) {
    const { id } = thermometer;
    const [thermometer_key] = getZ3kEntityById(z3k_config, id);
    if (!thermometer_key) {
        return null;
    }
    if (thermometer_key === 'wired_temperature_sensors') {
        const z3k_wired_thermometer = thermometer;
        const wired_thermometer = getWiredSensorThermometer(z3k_wired_thermometer);
        return {
            ...wired_thermometer,
            thermometer_key: Z3kSecondRoutes.wired_temperature_sensors,
        };
    }
    if (thermometer_key === 'radiosensors') {
        const z3k_radio_sensor_thermometer = thermometer;
        const wired_thermometer = getRadioSensorThermometer(z3k_radio_sensor_thermometer);
        return {
            ...wired_thermometer,
            thermometer_key: Z3kSecondRoutes.radiosensor868,
        };
    }
    if (thermometer_key === 'analog_temperature_sensors') {
        const z3k_analog_thermometer = thermometer;
        const analog_thermometer = getAnalogSensorThermometer(z3k_analog_thermometer);
        return {
            ...analog_thermometer,
            thermometer_key: Z3kSecondRoutes.analog_temperature_sensors,
        };
    }
    if (thermometer_key === 'boiler_adapters') {
        const z3k_boiler_adapter_thermometer = thermometer;
        const boiler_adapter_thermometer = getBoilerAdapterThermometer(z3k_boiler_adapter_thermometer, z3k_config, index);
        return {
            ...boiler_adapter_thermometer,
            thermometer_key: Z3kSecondRoutes.boiler_adapters,
        };
    }
    return null;
}
export function getZ3KThermometersConfig(z3k_config) {
    const thermometers = getThermometers(z3k_config);
    const shared_thermometers = thermometers.map((thermometer, index) => getSharedThermometer(thermometer, z3k_config, index));
    return shared_thermometers;
}
